<div class="modal configure-feature" id="myModal" tabindex="-1" role="dialog">
  @if (loading()) {
    <img
      id="configure-device-loading-spinner"
      class="dash-border text-secondary custom-spinner"
      src="{{ pathVal }}{{ pathVal }}dash-spinner.gif"
      alt="Loading" />
  }
  <div class="modal-dialog featureDialog" id="feature" role="document">
    <div class="modal-content featureModalContent modal-content" id="featureModal">
      <div class="row upload-container">
        <div id="configure-device-title" class="col-3 signifyBoldmd select-file">Configure box</div>
        <div class="col-9"></div>
      </div>
      <div class="row box-container-margin" id="Input">
        <div class="col-7 box-container">
          <br>
            <div id="configure-device-input-label" class="signifyBoldlg marl-110">Number of devices to be configured:
              <input
                id="configure-device-count-input"
                type="number"
                [disabled]="loading()"
                [(ngModel)]="ngModelval['boxSize']"
                (ngModelChange)="numberOfDevices($event)"
                (keypress)="numberOnly($event)"
                min="1"
                max="50"
                class="custom textInput wide-input"
                />


                <div style="margin-top:8px;">
                  @if (wrongInputValue()) {
                    <span id="configure-device-validation-message" class="signifyBoldsm">
                      <img id="configure-device-validation-icon" class="tick-img" src="{{pathVal}}caution_orange.png" alt="Caution">&nbsp; Please enter a value between 1 and 50
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="col-5"></div>
          </div>
          <div id="cancel">
            <div class="col-7 d-flex justify-content-end flex-row no-padding-end button-group-no-gap">
              <button id="configure-device-cancel-button" type="button" class="btn prev-btn pos2" (click)="[activemodal.dismiss('Cross click'),onCancel()]">Cancel</button>
              <button
                id="configure-device-next-button"
                type="button"
                class="btn next-btn pos"
                [ngClass]="{'disabled-btn': !ngModelval['boxSize'] || ngModelval['boxSize'] <1 || ngModelval['boxSize'] >50}"
                (click)="[activemodal.dismiss('Cross click'), onNext()]"
                [disabled]="!ngModelval['boxSize'] || ngModelval['boxSize'] <1 || ngModelval['boxSize'] >50"
                >
                Next
              </button>

            </div>
          </div>
        </div>
      </div>
